import { render, staticRenderFns } from "./RedesignBanner.vue?vue&type=template&id=7142f886&scoped=true"
import script from "./RedesignBanner.vue?vue&type=script&lang=js"
export * from "./RedesignBanner.vue?vue&type=script&lang=js"
import style0 from "./RedesignBanner.vue?vue&type=style&index=0&id=7142f886&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7142f886",
  null
  
)

export default component.exports